import React from 'react';
import styled from 'styled-components';
import { FontSize } from 'web-common/src/shared/styles';

interface LoginLinkProps {
  onClick: React.MouseEventHandler;
  text?: React.ReactNode;
}

const StyledLoginLink = styled.div`
  text-decoration: underline;
  font-size: ${FontSize.S};
  cursor: pointer;
`;
export const LoginLink: React.FC<LoginLinkProps> = ({ onClick, text = 'Log in' }) => (
  <StyledLoginLink onClick={onClick}>{text}</StyledLoginLink>
);
